import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { AvailityResult } from '@app/graphql/service/schema'
import { Field } from '@app/api/types'

import { CostCalculatorState, CostCalculatorOutput } from './types'

const INITIAL_STATE: CostCalculatorState = {
  status: 'initial',
  error: '',
  inputData: {
    email: '',
    name: '',
    phone: '',
    provider: '',
    dob: '',
    memberId: ''
  },
  outputData: [],
  insuranceRequest: {
    status: 'initial',
    result: null
  },
  insuranceCostReport: {
    status: 'initial',
    error: '',
    result: {
      status: '',
      statusCode: '',
      requestId: '',
      coInsurance: '',
      remainingOutOfPocket: '',
      isOutOfNetwork: false
    }
  }
}

export const slice = createSlice({
  name: 'costCalculator',
  initialState: INITIAL_STATE,

  reducers: {
    updateCostCalculatorOutput: (state, action: PayloadAction<CostCalculatorOutput[]>) => {
      state.status = 'initial'
      state.outputData = action.payload
    },
    requestInitCostCalculator: state => {
      state.status = 'pending'
    },
    successInitCostCalculator: state => {
      state.status = 'success'
    },
    errorInitCostCalculator: (state, action: PayloadAction<{ message: string }>) => {
      state.status = 'failure'
      state.error = action.payload.message
    },
    requestUpdateCostCalculatorInputData: state => {
      state.status = 'pending'
    },
    successUpdateCostCalculatorInputData: (state, { payload: { fieldName, fieldValue } }: PayloadAction<Field>) => {
      state.status = 'success'
      state.inputData[fieldName] = fieldValue
    },
    errorUpdateCostCalculatorInputData: (state, action: PayloadAction<string>) => {
      state.status = 'failure'
      state.error = action.payload
    },
    requestInitInsuranceCoverageReport: state => {
      state.insuranceRequest.status = 'pending'
    },
    successInitInsuranceCoverageReport: (state, action: PayloadAction<string | null>) => {
      state.insuranceRequest.status = 'success'
      state.insuranceRequest.result = action.payload
    },
    errorInitInsuranceCoverageReport: (state, action: PayloadAction<string>) => {
      state.insuranceRequest.status = 'failure'
      state.error = action.payload
    },
    requestFetchInsuranceCostReport: state => {
      state.insuranceCostReport.status = 'pending'
    },
    successFetchInsuranceCostReport: (state, action: PayloadAction<AvailityResult>) => {
      state.insuranceCostReport.status = 'success'
      state.insuranceCostReport.result = action.payload
    },
    errorFetchInsuranceCostReport: (state, action: PayloadAction<string>) => {
      state.insuranceCostReport.status = 'failure'
      state.error = action.payload
    }
  }
})

export const { actions } = slice

export const costCalculatorReducer = slice.reducer
